import { getSelectedRect } from '@blocksuite/affine-shared/utils';
import type { GfxModel } from '@blocksuite/std/gfx';

export function resolveRemoteSelectionPresentation(elements: GfxModel[]): {
  rect: DOMRect;
  rotate: number;
} {
  const rect = getSelectedRect(elements);
  const rotate = elements.length === 1 ? (elements[0]?.rotate ?? 0) : 0;

  return { rect, rotate };
}
